export const getAuthenticatedUserProfile = (userData) => {
  const givenName = userData?.profile?.given_name ?? "";
  const familyName = userData?.profile?.family_name ?? "";
  const hasStructuredName = Boolean(givenName && familyName);
  const fullNameFromParts = hasStructuredName
    ? `${givenName} ${familyName}`
    : "";

  return {
    fullName: fullNameFromParts || userData?.profile?.name || "",
    username: userData?.profile?.preferred_username ?? "",
    email: userData?.profile?.email ?? "",
    accessToken: userData?.access_token ?? "",
  };
};
